/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import withClass from '../../../util/withClass';
var SubDescriptionList = Object.assign(withClass('dl', 'nx-vulnerability-details__sub-description-list'), {
    Container: withClass('div', 'nx-vulnerability-details__sub-description-container'),
    Term: withClass('dt', 'nx-vulnerability-details__sub-description-term'),
    Desc: withClass('dd', 'nx-vulnerability-details__sub-description-desc')
});
export default SubDescriptionList;
//# sourceMappingURL=SubDescriptionList.js.map